module.exports = __webpack_public_path__ + "static/assets/c63ed594cc3195dcef31fc11a6bf034d.svg";